import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useTokenBootstrap } from 'hooks/use-token-bootstrap';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function SessionBootstrap({ children }) {
  useTokenBootstrap();
  return children;
}

export default function AppProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionBootstrap>{children}</SessionBootstrap>
    </QueryClientProvider>
  );
}
